import { createLogger } from "@/logger";
import { recordEvent } from "@/services/telemetry";

const log = createLogger("telemetry");

/** A long task must block the main thread for at least this long to count as a stall. */
const STALL_THRESHOLD_MS = 2_000;
/** Floor between reports so a thrashing session can't flood the (unsampled) reliability bucket. */
const MIN_REPORT_INTERVAL_MS = 30_000;

/**
 * Page-not-responding proxy: watches `longtask` performance entries and reports main-thread stalls
 * above {@link STALL_THRESHOLD_MS} as reliability events, rate-limited per session.
 */
export function initializeStallDetector(): void {
  if (typeof PerformanceObserver === "undefined") return;
  let lastReportMs = 0;
  try {
    const observer = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (entry.duration < STALL_THRESHOLD_MS) continue;
        const now = Date.now();
        if (now - lastReportMs < MIN_REPORT_INTERVAL_MS) continue;
        lastReportMs = now;
        recordEvent("page.stall", {
          stall: { durationMs: Math.round(entry.duration), entryName: entry.name },
        });
      }
    });
    observer.observe({ type: "longtask", buffered: true });
  } catch (error) {
    log.debug("[stallDetector] longtask observation unavailable", { error });
  }
}
